import React, { useEffect, type JSX } from 'react';
import { Reparaturweg } from '../../components/Reparaturweg';
import { SchadenbedingterFahrzeugzustand } from '../../components/SchadenbedingterFahrzeugzustand';
import { ReparaturhinweisAuswahl } from '../../components/ReparaturhinweisAuswahl';
import { useLocation, useNavigate } from 'react-router-dom';
import { useVorgangContext } from '../../contexts/vorgangContext';
import { Gutachtenart } from '../../shared/constants';

export default function Schadenbemerkungen(): JSX.Element {
  const { vorgang, isLoading, aktualisiereVorgang } = useVorgangContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.includes('schadenbemerkungen') && vorgang?.gutachtenart === Gutachtenart.FAHRZEUGBEWERTUNG) {
      navigate(location.pathname.replace('/schadenbemerkungen', ''));
    }
  }, [location.pathname, navigate, vorgang]);

  return (
    <>
      {vorgang?.gutachtenart !== Gutachtenart.REPARATURNACHWEIS ? (
        <>
          <SchadenbedingterFahrzeugzustand vorgang={vorgang} isLoading={isLoading} aktualisiereVorgang={aktualisiereVorgang} />
          <br />
          <Reparaturweg vorgang={vorgang} isLoading={isLoading} aktualisiereVorgang={aktualisiereVorgang} />
        </>
      ) : (
        <ReparaturhinweisAuswahl vorgang={vorgang} isLoading={isLoading} aktualisiereVorgang={aktualisiereVorgang} />
      )}
    </>
  );
}
